module.exports = __webpack_public_path__ + "img/园区.a9f5b115.gif";